<mat-toolbar color="primary">
  <mat-toolbar-row class="toolbar">
    <button [routerLink]="['/kontakt']" mat-button color="#5D4037" class="footer-tab">Kontakt</button>
    <button [routerLink]="['/impressum']" mat-button color="#5D4037" class="footer-tab">Impressum</button>
  </mat-toolbar-row>
</mat-toolbar>